export const setBrowserIE = ({ dispatch }, isIE) => dispatch('SET_BROWSER_IE', isIE)
export const setBrowserSafari = ({ dispatch }, isSafari) => dispatch('SET_BROWSER_SAFARI', isSafari)

export const setMobileSize = ({ dispatch }, isMobileSize) => dispatch('SET_MOBILE_SIZE', isMobileSize)
export const setMobileAgent = ({ dispatch }, isMobileAgent) => dispatch('SET_MOBILE_AGENT', isMobileAgent)

export const enableGlobalOverlay = ({ dispatch }) => dispatch('ENABLE_GLOBAL_OVERLAY')
export const disableGlobalOverlay = ({ dispatch }) => dispatch('DISABLE_GLOBAL_OVERLAY')

export const playEnvironmentSound = ({ dispatch }) => dispatch('PLAY_ENV_SOUND')
export const stopEnvironmentSound = ({ dispatch }) => dispatch('STOP_ENV_SOUND')
export const setSoundSupported = ({ dispatch }, isSupported) => dispatch('SET_SOUND_SUPPORTED', isSupported)

export const openNavMenu = ({ dispatch }) => dispatch('OPEN_NAV_MENU')
export const closeNavMenu = ({ dispatch }) => dispatch('CLOSE_NAV_MENU')
export const openNavMenuDelay = ({ dispatch }) => dispatch('OPEN_NAV_MENU_DELAY')
export const closeNavMenuDelay = ({ dispatch }) => dispatch('CLOSE_NAV_MENU_DELAY')

export const openHotspotPanel = ({ dispatch }, hotspot, hotspotsContent) => dispatch('OPEN_HOTSPOT_PANEL', hotspot, hotspotsContent)
export const closeHotspotPanel = ({ dispatch }) => dispatch('CLOSE_HOTSPOT_PANEL')

export const openFullscreenVideo = ({ dispatch }, youtubeId, useDefaultPreloader) => dispatch('OPEN_FULLSCREEN_VIDEO', youtubeId, useDefaultPreloader)
export const setFullScreenVideoReady = ({ dispatch }) => dispatch('SET_FULLSCREEN_VIDEO_READY')
export const closeFullscreenVideo = ({ dispatch }) => dispatch('CLOSE_FULLSCREEN_VIDEO')



// WEBPACK FOOTER //
// ./src/vuex/actions.js